import { validateStepSetChoice } from '../task-progress/validate-step-choice';
export function processProgressToProgressMap(progress, nodeMap) {
    var map = {};
    // there's no progression data, return an empty progress-map
    if (progress == null) {
        return map;
    }
    Object.keys(progress).forEach(function (stepId) {
        var stepProgress = progress[stepId];
        if (!nodeMap.hasOwnProperty(stepId)) {
            // outdated progress object, the step/procedure isn't in the process anymore
            return;
        }
        var completed = null;
        if (stepProgress.completed != null) {
            var _a = validateStepSetChoice(stepProgress.set_choice, nodeMap[stepId]), pickedChoice = _a.pickedChoice, nextNode = _a.nextNode;
            completed = {
                at: stepProgress.completed,
                by: stepProgress.completed_by || null,
                pickedChoice: pickedChoice,
                nextNode: nextNode,
            };
        }
        map[stepId] = {
            fields: {},
            completed: completed,
        };
    });
    return map;
}
